module.exports = __webpack_public_path__ + "static/media/ascent-logo-white.11e4ab26.svg";